import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
   @import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap');
  * {
      margin: 0;
      padding:0;
      outline: 0;
      box-sizing: border-box;

      scrollbar-color: rgb(97, 9, 138, 0.2) white;
      scrollbar-width: thin;

      &::-webkit-scrollbar {
        width: 8px;
      }

      /* Track */
      &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgb(97, 9, 138, 0.2);
        /* -webkit-border-radius: 10px;
          border-radius: 10px; */
      }

      /* Handle */
      &::-webkit-scrollbar-thumb {
        /* -webkit-border-radius: 10px; */
        border-radius: 10px;
        background: rgb(97, 9, 138, 0.2);
        /* -webkit-box-shadow: inset 0 0 6px rgb(97, 9, 138);  */
      }
      &::-webkit-scrollbar-thumb:window-inactive {
        background: rgb(97, 9, 138, 0.1);
      }      
  }

  :not(input):not(textarea){
    -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
  }

  body{
    /* background: #fafafa; */
    background: #fff;
      text-rendering: optimizeLegibility !important;
     -webkit-font-smothing: antialiased !important;
  }


  body, html {
     height: 100vh;
     margin: 0px;
  }

  input:focus{
    border: 1.1px solid rgba(73,70,226,0.46)!important;
    -webkit-box-shadow: 0px 0px 3px 2px rgba(73,70,226,0.46)!important;
    -moz-box-shadow: 0px 0px 3px 2px rgba(73,70,226,0.46)!important;
    box-shadow: 0px 0px 3px 2px rgba(73,70,226,0.46)!important;
  }

  textarea:focus{
    border: 1.1px solid rgba(73,70,226,0.46)!important;
    -webkit-box-shadow: 0px 0px 3px 2px rgba(73,70,226,0.46)!important;
    -moz-box-shadow: 0px 0px 3px 2px rgba(73,70,226,0.46)!important;
    box-shadow: 0px 0px 3px 2px rgba(73,70,226,0.46)!important;
  }

  select:focus{
    -webkit-box-shadow: 0px 0px 3px 2px rgba(73,70,226,0.46)!important;
    -moz-box-shadow: 0px 0px 3px 2px rgba(73,70,226,0.46)!important;
    box-shadow: 0px 0px 3px 2px rgba(73,70,226,0.46)!important;
  }

/* .directTituloJanela{
  margin-left: 54px!important;
  width: 100vw!important;
} */
  #root{
      width: 100%;
      margin: 0 auto;
  }

  .Toastify__toast--error .Toastify__toast-body{
    color: #fff;
    white-space: pre-line;
  }

  .Toastify__toast-body{
    color: #fff;
    white-space: pre-line;
  }
  .tab-content{
    border: 1px solid #bdc3c7;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .tabs{
    padding: 5px 30px 5px 60px;
  }
  .tab-list {
    padding-left: 0;
  }

  .tab-list-item {
    display: inline-block;
    list-style: none;
    margin-bottom: -1px;
    padding: 0.5rem 0.75rem;
    cursor: pointer;
    padding-top: 10px;
  }

  .tab-list-active {
    background-color: white;
    border: solid #bdc3c7;
    border-width: 1px 1px 0 1px;
  }

  /* ESTILIZAÇÃO USER-TITLE */
  div ul li h4 {
    margin: 1.52rem 0 0 0;
    padding: 10px 0 5px 10px;
  }

  div ul li div svg {
    color: rgb(255, 255, 255);
    border-color: white;
    border-style: solid;
    border-width: 1px;
    margin: 10px;
    padding: 2px;
  }

  .sidenav{
    scrollbar-color: #61098a white;
    scrollbar-width: thin;
  }

/* Let's get this party started */
::-webkit-scrollbar {
    width: 10px;
}
 
/* Track */
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgb(97, 9, 138, 0.2); 
    /* -webkit-border-radius: 10px;
    border-radius: 10px; */
}
 
/* Handle */
::-webkit-scrollbar-thumb {
    /* -webkit-border-radius: 10px; */
    border-radius: 10px;
    background: rgb(97, 9, 138, 0.2); 
    /* -webkit-box-shadow: inset 0 0 6px rgb(97, 9, 138);  */
}
::-webkit-scrollbar-thumb:window-inactive {
	background: rgb(97, 9, 138, 0.1); 
}


  /* BOTÃO DE SUB-MENU SIDENAV */
  /* a.waves-effect {
    width: 90%;
  } */
  button.btn.dropdown-trigger {
    background-color: transparent;
    border-style: none;
    box-shadow: none;
  }
  .dropdown-content{
    width: 100%!important;
  }
  ul li button i.material-icons {
    color: black;
  }

  /* ESTILIZAÇÃO PANEL */
  .tabs .indicator {
    background-color: #61098a!important;
  }
  .tabs .tab a {
    color: #61098a!important;
  }
  .tabs .tab a:focus, .tabs .tab a:focus.active {
    background-color: rgba(97, 9, 138, 0.1)!important;
    outline: none!important;
  }

  /* ESTILIZAÇÃO DATA TABLES */
  .rdt_Pagination{
    box-shadow: none;
    border-top-style: none;
    border-top-width: 0px;
    border-top-color: none;
    padding-right: 0px;
    padding-left: 0px;
  }

  /* ESTILIZAÇÃO BOTÕES SAIBWEB */
  button{
        cursor: pointer;
  }

  @-webkit-keyframes spinAround {
    from {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }

    to {
      -webkit-transform: rotate(359deg);
      transform: rotate(359deg);
    }
  }

  @keyframes spinAround {
    from {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }

    to {
      -webkit-transform: rotate(359deg);
      transform: rotate(359deg);
    }
  }


  .saib-button.is-primary {
    background: #61098A;
    border: 1px solid #61098A;
    border-radius: 100px;
    color: #ffffff;
    cursor: pointer;
    display: inline-block;
    font-family: "Roboto";
    font-size: 16px;
    font-style: normal;
    letter-spacing: 0.4px;
    font-weight: 600;
    letter-spacing: 0.4px;
    line-height: normal;
    padding: 4px 12px;
    text-align: center;
  }
  .saib-button.is-primary:focus {
    background: #61098A;
  }

  .saib-button.is-primary span {
    font-stretch: ultra-condensed;
    /* font-weight: 900; */
  }

  @media (min-width: 576px) {
    .saib-button.is-primary {
      min-width: 80px;
      width: auto;
    }
  }

  .saib-button.is-primary:focus,
  .saib-button.is-primary.is-focus {
    -webkit-box-shadow: 0 3px 6px -3px #61098A;
    box-shadow: 0 3px 6px -3px #61098A;
    outline: 0;
  }
  .saib-button.is-primary:hover,
  .saib-button.is-primary.is-hover {
    background-color: #7E3A9D;
    border-color: #7E3A9D;
    color: #ffffff;
    text-decoration: none;
  }
  .saib-button.is-primary:disabled,
  .saib-button.is-primary.is-disabled {
    background: #999798;
    border-color: #999798;
    color: #ffffff;
    cursor: default;
  }

  .saib-button.is-secondary {
    background: #ffffff;
    border: 1px solid #61098A;
    border-radius: 100px;
    color: #61098A;
    cursor: pointer;
    display: inline-block;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    letter-spacing: 0.4px;
    line-height: normal;
    padding: 4px 12px;
    text-align: center;
    width: 100%;
  }
  .saib-button.is-secondary span {
    font-stretch: ultra-condensed;
    /* font-weight: 900; */
  }

  @media (min-width: 576px) {
    .saib-button.is-secondary {
      min-width: 80px;
      width: auto;
    }
  }

  .saib-button.is-secondary:focus,
  .saib-button.is-secondary.is-focus {
    -webkit-box-shadow: 0 3px 6px -3px #61098A;
    box-shadow: 0 3px 6px -3px #61098A;
    outline: 0;
  }
  .saib-button.is-secondary:hover,
  .saib-button.is-secondary.is-hover {
    background-color: #7E3A9D;
    border-color: #7E3A9D;
    color: #ffffff;
    text-decoration: none;
  }
  .saib-button.is-secondary:disabled,
  .saib-button.is-secondary.is-disabled {
    background: #999798;
    border-color: #999798;
    color: #ffffff;
    cursor: default;
  }

  .saib-button.is-tertiary {
    background: transparent;
    border: 0;
    color: #61098A;
    cursor: pointer;
    padding: 0;
  }
  .saib-button.is-tertiary:focus,
  .saib-button.is-tertiary.is-focus {
    outline: 0;
    text-shadow: 0 3px 6px currentColor;
  }
  .saib-button.is-tertiary:hover,
  .saib-button.is-tertiary.is-hover {
    color: #7E3A9D;
    text-decoration: underline;
  }
  .saib-button.is-tertiary:disabled,
  .saib-button.is-tertiary.is-disabled {
    color: #999798;
    cursor: default;
  }

  .saib-button.is-cancel {
    background: transparent;
    border: 0;
    color: #555555;
    cursor: pointer;
    padding: 0;
    box-shadow: none;
  }
  .saib-button.is-cancel:focus,
  .saib-button.is-cancel.is-focus {
    outline: 0;
    text-shadow: 0 3px 6px currentColor;
  }
  .saib-button.is-cancel:hover,
  .saib-button.is-cancel.is-hover {
    color: #7E3A9D;
    text-decoration: underline;
  }
  .saib-button.is-cancel:disabled,
  .saib-button.is-cancel.is-disabled {
    color: #999798;
    cursor: default;
  }

  .saib-button.is-call-to-action {
    background: #BD207B;
    border: 1px solid #f3f3f3;
    border-radius: 100px;
    border-width: 5px;
    color: #ffffff;
    cursor: pointer;
    display: inline-block;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: 0.4px;
    line-height: normal;
    padding: 4px 12px;
    text-align: center;
    width: 100%;
  }

  @media (min-width: 576px) {
    .saib-button.is-call-to-action {
      min-width: 80px;
      width: auto;
    }
  }

  .saib-button.is-call-to-action:focus,
  .saib-button.is-call-to-action.is-focus {
    -webkit-box-shadow: 0 1.5px 3px -1.5px #61098A;
    box-shadow: 0 1.5px 3px -1.5px #61098A;
    outline: 0;
  }
  .saib-button.is-call-to-action:hover,
  .saib-button.is-call-to-action.is-hover {
    background-color: #7E3A9D;
    border-color: #7E3A9D;
    color: #ffffff;
    text-decoration: none;
  }
  .saib-button.is-call-to-action:disabled,
  .saib-button.is-call-to-action.is-disabled {
    background: #999798;
    border-color: #999798;
    color: #ffffff;
    cursor: default;
  }

  @media (min-width: 576px) {
    .saib-button.is-call-to-action {
      min-width: 80px;
    }
  }

  .saib-button.is-call-to-action:focus,
  .saib-button.is-call-to-action.is-focus {
    -webkit-box-shadow: 0 3px 6px -3px #BD207B;
    box-shadow: 0 3px 6px -3px #BD207B;
  }
  .saib-button.is-call-to-action:hover,
  .saib-button.is-call-to-action.is-hover {
    background-color: #F071BA;
    border-color: #f3f3f3;
    color: #ffffff;
    text-decoration: none;
  }

  .saib-button.is-circle {
    align-items: center;
    border-radius: 50% !important;
    -webkit-box-align: center;
    -webkit-box-pack: center;
    display: -webkit-inline-box !important;
    display: -ms-inline-flexbox !important;
    display: inline-flex !important;
    -ms-flex-align: center;
    -ms-flex-pack: center;
    height: 18px !important;
    justify-content: center;
    padding: 0 !important;
    width: 18px !important;
  }

  @media (min-width: 576px) {
    .saib-button.is-circle {
      height: 18px !important;
      min-width: 0;
      width: 18px !important;
    }
  }

  .saib-button.is-circle img {
    width: 100%;
  }
  .saib-button.is-circle:not(.is-primary):not(.is-secondary) {
    border-color: transparent;
  }

  .saib-button.is-go-top {
    align-items: center;
    background: transparent;
    border: 0;
    -webkit-box-align: center;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -ms-flex-align: center;
    font-size: 12px;
    letter-spacing: 0.4px;
    /* font-weight: 800; */
    margin: 0;
    padding: 0;
    text-transform: uppercase;
  }
  .saib-button.is-go-top .saib-button {
    margin-left: 4px;
  }
  .saib-button.is-go-top:hover .saib-button,
  .saib-button.is-go-top:focus .saib-button {
    background-color: #7E3A9D;
    border-color: #7E3A9D;
  }
  .saib-button.is-go-top:disabled .saib-button {
    background: #999798;
    border-color: #999798;
  }

  .saib-button.is-filter {
    align-items: center;
    background: transparent;
    border: 0;
    -webkit-box-align: center;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -ms-flex-align: center;
    margin: 0;
    padding: 0;
  }
  .saib-button.is-filter .fas {
    color: #61098A;
    margin-left: 4px;
  }
  .saib-button.is-filter:hover .fas,
  .saib-button.is-filter:focus .fas {
    color: #7E3A9D;
  }
  .saib-button.is-filter:disabled .fas {
    color: #999798;
  }

  .saib-button.is-loading {
    color: transparent !important;
    pointer-events: none;
    position: relative;
  }
  .saib-button.is-loading::after {
    -webkit-animation: spinAround 500ms infinite linear;
    animation: spinAround 500ms infinite linear;
    border: 2px solid currentColor;
    border-radius: 50%;
    border-right-color: transparent;
    border-top-color: transparent;
    content: "";
    display: block;
    height: 1em;
    left: calc(45% - (1em / 2));
    position: absolute !important;
    top: calc(45% - (1em / 2));
    width: 1em;
  }
  .saib-button.is-loading.is-primary::after,
  .saib-button.is-loading.is-call-to-action::after {
    border-color: transparent transparent #ffffff #ffffff !important;
  }
  .saib-button.is-loading.is-secondary::after {
    border-color: transparent transparent #61098A #61098A !important;
  }

  .saib-button + .saib-button {
    margin-top: 8px;
  }

  @media (min-width: 576px) {
    .saib-button + .saib-button {
      margin-left: 6px;
      margin-top: 0;
    }
  }

  .saib-button.is-facebook {
    background: #3b5998;
    color: #ffffff;
  }
  .saib-button.is-twitter {
    background: #00aced;
    color: #ffffff;
  }
  /*# sourceMappingURL=button.css.map */

/*   .botao-sair{
    width: 210px;
    background-color: #BD207B!important;
    display:flex!important;
    justify-content: center;
    margin-top: 10px;
  }
  .botao-sair:hover{
    background-color: #F071BA!important;
  }
  .botao-sair i {
    color: white!important;
  }
 */
`;
